import React from 'react';
import Button from '@dbk/ui-buttons';

const TradeCTAButton = (props) => {
  const { className, message, handleClick, fetchInProgress , tertiary, secondary, disabled} = props;

  return (
  <div className="security-list-item-cta">
        <Button
            className={className}
            testID="btn_trade_search_cta_{message}"
            accessibilityLabel="btn_trade_search_{message}"
            onPress={() => handleClick()}
            size={'large'}
            loading={fetchInProgress}
            tertiary={tertiary}
            secondary={secondary}
            disabled={disabled}>
            {message}
          </Button>
    </div>
      )
  }

export default TradeCTAButton;
